import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';
const PropertyHomePage = () =>
  import('@modules/property/components/property-home-page.vue');
const PropertyListPage = () =>
  import('@modules/property/components/property-list-page.vue');
const PropertyFormPage = () =>
  import('@modules/property/components/property-form-page.vue');
const PropertyViewPage = () =>
  import('@modules/property/components/property-view-page.vue');
const PropertyImporterPage = () =>
  import('@modules/property/components/property-importer-page.vue');
const PropertyWalletPage = () =>
  import('@modules/property/components/property-wallet-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'property',
        path: '/property',
        component: PropertyHomePage,
        meta: {
          auth: true,
          permission: Permissions.values.propertyView,
        },
      },
      {
        name: 'propertyWallet',
        path: '/property/wallet',
        component: PropertyWalletPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertyView,
        },
        props: true,
      },
      {
        name: 'propertyList',
        path: '/property/list',
        component: PropertyListPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertyView,
        },
      },
      {
        name: 'propertyNew',
        path: '/property/new',
        component: PropertyFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertyCreate,
        },
      },
      {
        name: 'propertyImporter',
        path: '/property/import',
        component: PropertyImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertyImport,
        },
      },
      {
        name: 'propertyEdit',
        path: '/property/:id/edit',
        component: PropertyFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertyEdit,
        },
        props: true,
      },
      {
        name: 'propertyView',
        path: '/property/:id',
        component: PropertyViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertyView,
        },
        props: true,
      },
    ],
  },
];
